


























































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ThemeConfig } from "@/plugins/config";

@Component({
  name: "practice-login",
})
export default class PracticeLogin extends Vue {
  @Getter("theme")
  public theme!: ThemeConfig;
}
